<script setup lang="ts">
import ServiceSettingAddStep2 from "@/views/playground/planner/order-management/service-setting/add/ServiceSettingAddStep2.vue";
</script>

<template>
  <service-setting-add-step2></service-setting-add-step2>
</template>

<style scoped></style>
